import React from 'react';
import './DocsViewer.css';

function DocsViewer({ lang }) {
  const docUrl = lang === 'zh' ? '/docs/zh.html' : '/docs/en.html';

  return (
    <div className="docs-viewer">
      <iframe
        src={docUrl}
        title={`Documentation - ${lang === 'zh' ? '中文' : 'English'}`}
        className="docs-iframe"
        frameBorder="0"
      />
    </div>
  );
}

export default DocsViewer;

